// extracted by mini-css-extract-plugin
export default {"wrapper":"Send_wrapper__xJPSZ","icon-container":"Send_icon-container__RU-Z6","icon":"Send_icon__IRv-E","card":"Send_card__5g9oY"};